import { BaseForm } from '~/base/BaseForm';
import { SurveyQuestionModel } from '~modules/surveys/models/SurveyQuestionModel';

export enum SurveyFormKeyEnum {
  isChecked = 'isChecked',
  textValue = 'textValue',
  happyIndex = 'happyIndex',
  answerId = 'answerId',
}

export enum SurveyFormField {
  questions = 'questions',
}

export class SurveyForm extends BaseForm {
  [SurveyFormField.questions]: SurveyQuestionModel[] = [];

  constructor(props?: unknown) {
    super(props);
    this.load(props);
  }
}
